import "./footer.css";


//new footer

const Footer = () => {
  return (

    
    <div className="footerContainer">
   

      <div className="footerbar">
            <div className="logohead">
                <div className="footlogosection" >
                  <div className="footLogo"></div>
                  <h3 style={{color:"#fff"}}>Mangalam Migration Services:</h3>
                  <p style={{color:"#fff"}}>Corporate Office: <br/>Delhi: 16, 17, 38 and 39 , Sevak Park, Uttam Nagar, West Delhi, <br/>New Delhi - 110059 </p>
                </div>
            </div>
      <div className="footlist">    
      <div className="fLists">
        <ul className="fList">
          <li className="fListItem">Countries</li>
          <li className="fListItem">Regions</li>
          <li className="fListItem">Cities</li>
          <li className="fListItem">Districts</li>
          <li className="fListItem">Airports</li>
          <li className="fListItem">Hotels</li>
        </ul>
        <ul className="fList">
          <li className="fListItem">Homes </li>
          <li className="fListItem">Apartments </li>
          <li className="fListItem">Resorts </li>
          <li className="fListItem">Villas</li>
          <li className="fListItem">Hostels</li>
          <li className="fListItem">Guest houses</li>
        </ul>
        <ul className="fList">
          <li className="fListItem">Unique places to stay </li>
          <li className="fListItem">Reviews</li>
          <li className="fListItem">Unpacked: Travel articles </li>
          <li className="fListItem">Travel communities </li>
          <li className="fListItem">Seasonal and holiday deals </li>
        </ul>
      </div>
      </div>  
    </div>
    <div className="footlist1">    
      <div className="fLists">
        <ul className="fList">
          <li className="fListItem fghghgh">Countries</li>
          <li className="fListItem fghghgh">Regions</li>
          <li className="fListItem fghghgh">Cities</li>
          <li className="fListItem fghghgh">Districts</li>
          <li className="fListItem fghghgh">Airports</li>
          <li className="fListItem fghghgh">Hotels</li>
        </ul>
        <ul className="fList">
          <li className="fListItem fghghgh">Homes </li>
          <li className="fListItem fghghgh">Apartments </li>
          <li className="fListItem fghghgh">Resorts </li>
          <li className="fListItem fghghgh">Villas</li>
          <li className="fListItem fghghgh">Hostels</li>
          <li className="fListItem fghghgh">Guest houses</li>
        </ul>
        <ul className="fList">
          <li className="fListItem fghghgh">Unique stays </li>
          <li className="fListItem fghghgh">Reviews</li>
          <li className="fListItem fghghgh">Travel articles </li>
          <li className="fListItem fghghgh">Travel communities </li>
          <li className="fListItem fghghgh">Holiday deals </li>
        </ul>
      </div>
      </div>
    </div>
  );
};

export default Footer;
